module.exports = __webpack_public_path__ + "img/category-brand-hover.91d85aa0.png";